module.exports = __webpack_public_path__ + "img/calendar.a75ede96.svg";